import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-settings-pop-up',
  templateUrl: './user-settings-pop-up.component.html',
})
export class UserSettingsPopUpComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
